import { FC, useEffect, useState } from 'react';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import useActiveTabFlag from '@utils/hooks/useActiveTabFlag';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Props {
  visible: boolean;
}

const rollingText = [
  '선호정보를 입력하면 나에게 딱 맞는 맞춤 포지션을 제안받을 수 있어요.',
  '정확한 선호정보와 경력입력으로 매칭경험을 받아보세요.',
  '전문 큐레이터가 나를 추천하고 기업이 직접 채용해요.',
  '입력하신 정보는 언제든지 내 프로필에서 수정 가능해요.',
];

const ANGLE = 360 / rollingText.length;

const RollingMessage: FC<Props> = ({ visible }) => {
  const [rotateX, setRotateX] = useState(0);
  const initFlag = useActiveTabFlag();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRotateX((prev) => prev - ANGLE);
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);

  if (!visible || !initFlag) return null;

  return (
    <div className={cx('exampleArea')}>
      <div className={cx('rollingArea')}>
        <Text fontStyle={FontStyle.B2_B} color={Colors.C_GREEN_150}>
          JOBDA
        </Text>

        <div className={cx('rotatorArea')}>
          <div
            className={cx('rotator')}
            style={{
              transform: `rotateX(${rotateX}deg)`,
            }}
          >
            {rollingText.map((text, idx) => (
              <div
                key={idx}
                className={cx('item')}
                style={{ transform: `rotateX(${idx * ANGLE}deg) translateZ(50px)` }}
              >
                {text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RollingMessage;
